<div class="login-page">
  <div class="content">
    <form class="login-form" (ngSubmit)="changePassword()" [formGroup]="changepasswordForm" novalidate>
      <div class="login-error" [hidden]="!error || isLoading" translate>
        {{ error }}
      </div>
      <div class="text-center">
        <h2 class="app-name">
          <img src="assets/images/logo.svg" />
        </h2>
      </div>
      <div class="login-fields" fxLayout="column">
        <mat-form-field [hideRequiredMarker]="true" appearance="outline">
          <mat-label>{{ 'auth.change-password.password.title' | translate }}</mat-label>

          <input
            id="mysecretpassword"
            [type]="hidePassword ? 'password' : 'text'"
            matInput
            formControlName="password"
            autocomplete="password"
            required
          />
          <mat-error
            *ngIf="changepasswordForm.controls.password.invalid && changepasswordForm.controls.password.touched"
          >
            <span translate>{{ 'auth.change-password.password.required' | translate }}</span>
          </mat-error>
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hidePassword"
          >
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field [hideRequiredMarker]="true" appearance="outline">
          <mat-label>{{ 'auth.change-password.confirm_password.title' | translate }}</mat-label>

          <input
            id="mysecretconpassword"
            [type]="hideConfirmPassword ? 'password' : 'text'"
            matInput
            formControlName="confirmPassword"
            autocomplete="confirmPassword"
            required
          />
          <mat-error
            *ngIf="
              changepasswordForm.controls.confirmPassword.invalid && changepasswordForm.controls.confirmPassword.touched
            "
          >
            <span translate>{{ 'auth.change-password.confirm_password.required' | translate }}</span>
          </mat-error>
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideConfirmPassword = !hideConfirmPassword"
            [attr.aria-label]="'Hide confirm password'"
            [attr.aria-pressed]="hideConfirmPassword"
          >
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <div class="error-summary">
          <label
            class="col error-text"
            [ngClass]="
              (changepasswordForm.controls['password'].hasError('required') ||
                changepasswordForm.controls['password'].hasError('minlength')) &&
              changepasswordForm.controls.password.touched
                ? 'text-danger'
                : changepasswordForm.controls.password.touched
                ? 'text-success'
                : ''
            "
          >
            <i class="material-icons error-icon">
              {{
                (changepasswordForm.controls['password'].hasError('required') ||
                  changepasswordForm.controls['password'].hasError('minlength')) &&
                changepasswordForm.controls.password.touched
                  ? 'clear'
                  : changepasswordForm.controls.password.touched
                  ? 'done'
                  : 'stop'
              }}
            </i>
            {{ 'auth.change-password.validation.eightCharacters' | translate }}
          </label>

          <label
            class="col error-text"
            [ngClass]="
              (changepasswordForm.controls['password'].hasError('required') ||
                changepasswordForm.controls['password'].hasError('hasSpecialCharacters')) &&
              changepasswordForm.controls.password.touched
                ? 'text-danger'
                : changepasswordForm.controls.password.touched
                ? 'text-success'
                : ''
            "
          >
            <i class="material-icons error-icon">
              {{
                (changepasswordForm.controls['password'].hasError('required') ||
                  changepasswordForm.controls['password'].hasError('hasSpecialCharacters')) &&
                changepasswordForm.controls.password.touched
                  ? 'clear'
                  : changepasswordForm.controls.password.touched
                  ? 'done'
                  : 'stop'
              }}
            </i>
            {{ 'auth.change-password.validation.specialCharacter' | translate }}
          </label>

          <label
            class="col error-text"
            [ngClass]="
              (changepasswordForm.controls['password'].hasError('required') ||
                changepasswordForm.controls['password'].hasError('hasNumber') ||
                changepasswordForm.controls['password'].hasError('hasCapitalCase') ||
                changepasswordForm.controls['password'].hasError('hasSmallCase')) &&
              changepasswordForm.controls.password.touched
                ? 'text-danger'
                : changepasswordForm.controls.password.touched
                ? 'text-success'
                : ''
            "
          >
            <i class="material-icons error-icon">
              {{
                (changepasswordForm.controls['password'].hasError('required') ||
                  changepasswordForm.controls['password'].hasError('hasNumber') ||
                  changepasswordForm.controls['password'].hasError('hasCapitalCase') ||
                  changepasswordForm.controls['password'].hasError('hasSmallCase')) &&
                changepasswordForm.controls.password.touched
                  ? 'clear'
                  : changepasswordForm.controls.password.touched
                  ? 'done'
                  : 'stop'
              }}
            </i>
            {{ 'auth.change-password.validation.smallCapitalNumber' | translate }}
          </label>

          <label
            class="col error-text"
            [ngClass]="
              (changepasswordForm.controls['confirmPassword'].hasError('required') ||
                changepasswordForm.controls['confirmPassword'].hasError('NoPassswordMatch')) &&
              changepasswordForm.controls.confirmPassword.touched
                ? 'text-danger'
                : changepasswordForm.controls.confirmPassword.touched
                ? 'text-success'
                : ''
            "
          >
            <i class="material-icons error-icon">
              {{
                (changepasswordForm.controls['confirmPassword'].hasError('required') ||
                  changepasswordForm.controls['confirmPassword'].hasError('NoPassswordMatch')) &&
                changepasswordForm.controls.confirmPassword.touched
                  ? 'clear'
                  : changepasswordForm.controls.confirmPassword.touched
                  ? 'done'
                  : 'stop'
              }}
            </i>
            {{ 'auth.change-password.validation.match' | translate }}
          </label>
        </div>

        <br />
        <button mat-raised-button color="primary" type="submit" [disabled]="changepasswordForm.invalid || isLoading">
          <!--              <app-loader class="inline-loader" [isLoading]="isLoading"></app-loader>-->
          <span>{{ 'auth.change-password.set' | translate }}</span>
        </button>
      </div>
    </form>
  </div>
</div>
